export const epochStartDate = new Date('1970-01-01')
